import React, { useRef, useEffect } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import Markers from './Markers';
import { googleMaps } from 'config/index';
import NewRelicService from 'services/NewRelic'

let _map = null;
const options = {
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    draggable: false,
    scaleControl: false,
    zoomControl: false
};
const zoom = 8;
const center = { lat: -33.463275, lng: -70.654933 };

const AddressMap = (props) => {
    const mapWrap = useRef(null);

    const {isReference, location} = props;

    useEffect(() => {
        NewRelicService.sendPageAction({
            action: 'modalAddress',
            payload: {
                status: 'map',
                isReference,
                location: location ? location.lat() + ', ' +  location.lng() : null
            }
        })
    }, []);

    const _applyViewport = (viewport, _isReference) => {
        if(!_map) return false;

        _map.fitBounds(viewport);

        const $map = _map;
        const _options = {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false
        }

        _options.draggable = _isReference;
        _options.scaleControl = _isReference;
        _options.zoomControl = _isReference;

        $map.setOptions(_options);
    };

    const onMapMounted = ($map) => {
        _map = $map;
        if(!_map) return false;

        if(props.viewport){
            _applyViewport(props.viewport, props.isReference)
        }
    };

    const onMapUnmounted = () => {
        _map = null;
    };

    return <div className='modal-address-map' ref={mapWrap}>
        {isReference && <GoogleMap options={options} zoom={zoom} center={center} onLoad={onMapMounted} onUnmount={onMapUnmounted} mapContainerClassName='map'>
            <Markers location={location} isReference={isReference} />
        </GoogleMap>}
        <div className='modal-address-map-static'>
            {!isReference && <img width="516" src={`https://maps.googleapis.com/maps/api/staticmap?center=${location.lat()},${location.lng()}&markers=size:large%7Clabel:%7C${location.lat()},${location.lng()}&zoom=16&scale=2&size=516x312&maptype=roadmap&language=ES-cl&key=${googleMaps.api}&format=jpg&visual_refresh=true`} alt="Google Maps" />}
        </div>
    </div>;
};

AddressMap.propTypes = {
    isReference: PropTypes.bool,
    viewport: PropTypes.object,
    location: PropTypes.object
};

export default AddressMap;
